var _rect, _rect2, _circle, _rect3, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhotoUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 76,
    viewBox: "0 0 86 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.884398,
    y: 33.2138,
    width: 62.6993,
    height: 47.8097,
    rx: 5.5,
    transform: "rotate(-30.694 0.884398 33.2138)",
    stroke: "#E3E0FB",
    strokeDasharray: "5 5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.9219,
    y: 14.5352,
    width: 63.6993,
    height: 48.8097,
    rx: 6,
    fill: "#EFEDFC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45.3215,
    cy: 26.7824,
    r: 5.27464,
    fill: "#F7F6FC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_760_1532",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 14,
    width: 65,
    height: 48
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21.9219,
    y: 14.3984,
    width: 63.6993,
    height: 46.7487,
    fill: "#F7F6FC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_760_1532)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.4295 47.1419L71.6516 24.7891L47.4874 45.7427L34.9718 33.5039L13.9707 54.0405H55.9728L48.9183 47.1419H97.4295Z",
    fill: "#F7F6FC"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9219 46.668H85.6212V57.3403C85.6212 60.654 82.9349 63.3403 79.6212 63.3403H27.9219C24.6082 63.3403 21.9219 60.654 21.9219 57.3403V46.668Z",
    fill: "#F7F6FC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoUpload);
export default __webpack_public_path__ + "static/media/photoUpload.115fd5f83053964a84213313ccdece9b.svg";
export { ForwardRef as ReactComponent };